var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.recommendation)?_c('next-race-card',{attrs:{"result-id":_vm.resultId,"recommendation":_vm.recommendation,"show-road-link":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }